<div style="padding-left:10px; display:inline-block;">
    <div style="display:inline-block; padding-right:2px;">
        <button [disabled]="disableToggle('first')" (click)="firstStudent()" class="mat-nav-button" mat-stroked-button>
            <span>
                &lt;&lt;
            </span>
        </button>
    </div>

    <div style="display:inline-block; padding-right:5px;">
        <button [disabled]="disableToggle('previous')" (click)="previousStudent()" class="mat-nav-button"
            mat-stroked-button>
            <span>
                &lt;
            </span>
        </button>
    </div>

    <div style="display:inline-block; margin-top:-7px; margin-bottom:-13px; bottom: -3px; position:relative;">
        <!-- Virtual Dropdown -->
        <kendo-dropdownlist #dropdownlistRef 
            class="student-list"
            style="width: 250px;"
            [data]="students" 
            [valueField]="'Id'" 
            [textField]="'studentSelectionName'"
            [ngModel]="selectedStudent" 
            [virtual]="virtual" 
            *ngIf="!showEnrollmentDates"
            (selectionChange)="previousSelectedStudent = selectedStudent; 
            changeStudent($event, true)" (open)="open()">
        </kendo-dropdownlist>

        <!-- Normal Dropdown for Enrollment -->
        <kendo-dropdownlist #dropdownlistRef [data]="students" [valueField]="'Id'" [textField]="'studentSelectionName'"
            [ngModel]="selectedStudent" *ngIf="showEnrollmentDates" class="student-list"
            (selectionChange)="previousSelectedStudent = selectedStudent; changeStudent($event, true)" (open)="open()">
            <ng-template kendoDropDownListItemTemplate let-dataItem>
                {{ dataItem.studentSelectionName }}
                <span *ngIf="dataItem.WithdrawnDate != null"
                    style="color: rgba(0, 0, 0, .54) !important ; padding-left: 5px;">
                    Withdrawn {{ dataItem.WithdrawnDate|date:'MM/dd/yy' }}
                </span>
                <span *ngIf="dataItem.AddedOn != null"
                    style="color: #595959; background-color: #ffff99; padding-left: 5px;">
                    Added {{ dataItem.AddedOn|date:'MM/dd/yy' }}
                </span>
            </ng-template>
        </kendo-dropdownlist>
    </div>

    <div style="display:inline-block; padding-left:5px;">
        <button [disabled]="disableToggle('next')" (click)="nextStudent()" class="mat-nav-button" mat-stroked-button>
            <span>
                &gt;
            </span>
        </button>
    </div>

    <div style="display:inline-block; padding-left:2px;">
        <button [disabled]="disableToggle('last')" (click)="lastStudent()" class="mat-nav-button" mat-stroked-button>
            <span>
                &gt;&gt;
            </span>
        </button>
    </div>

    <div *ngIf="forStudentSearch" style="display:inline-block; padding-left:10px;">{{studentIndex + 1}} of
        {{students.length}}</div>
</div>
